<template>
  <div class="vote-container">
    <div class="rule" @click="bindToRank">排行榜</div>
    <div class="v-time">活动时间：1月10日-1月17日</div>
    <div class="vote-content" v-if="coachInfo">
      <div class="user-info">
        <img
          class="avatar"
          v-if="coachInfo.invite_user_info"
          :src="coachInfo.invite_user_info.head_img"
          alt=""
        />
        <div class="nickname" v-if="coachInfo.invite_user_info">{{
          coachInfo.invite_user_info.truename
        }}</div>
        <div>邀请您参与投票</div>
      </div>
      <div class="vote-info">
        <img class="dietitian-avatar" :src="coachInfo.c_img" alt="" />
        <div class="vote-right">
          <div class="dietitian-name">{{ coachInfo.c_name }}</div>
          <div class="dietitian-num">{{ coachInfo.vote_num }}票</div>
          <div class="dietitian-rank"
            >目前排名：{{ coachInfo.vote_rank }}名</div
          >
          <div class="dietitian-btn" @click="bindVote">给ta投票</div>
        </div>
      </div>
    </div>
    <div class="qrcode-container">
      <div class="q-title">免费领取价值199真人营养服务</div>
      <div class="q-text">新用户限时福利</div>
      <img
        class="q-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d588ee0621d3887b550851d3d2ae529d.jpg"
        alt=""
      />
      <div class="q-desc">添加助教激活服务</div>
    </div>
    <!-- 营养师信息 -->
    <div class="dietitian-info" v-if="coachInfo && coachInfo.id">
      <div class="content-item" v-if="coachInfo.qualifications">
        <div class="item-title qualifications-title">ta的资质</div>
        <div class="qualifications-list">
          <div
            class="circle-item qualifications-item"
            v-for="(item, index) in coachInfo.qualifications"
            :key="index"
            >{{ item }}</div
          >
        </div>
      </div>
      <div class="content-item">
        <div class="item-title experience-title">ta的经验</div>
        <div class="experience-list">
          <div class="circle-item experience-item"
            >累计指导学员数:<span class="item-num">{{
              coachInfo.members
            }}</span>
          </div>
          <div class="circle-item experience-item"
            >累计帮助学员减重(kg):<span class="item-num">{{
              coachInfo.weights
            }}</span></div
          >
        </div>
      </div>
      <div class="content-item comment-container" v-if="coachInfo.praise">
        <div class="item-title comment-title">学员好评</div>
        <div class="comment-list">
          <div
            class="comment-item"
            v-for="(item, index) in coachInfo.praise"
            :key="index"
            >{{ item }}</div
          >
        </div>
      </div>
      <div class="change-container" v-if="coachInfo.case">
        <div class="item-title change-title">ta的学员蜕变日记</div>
        <div class="swipe-container">
          <van-swipe :loop="false" :width="swiperWidth">
            <van-swipe-item
              v-for="(item, index) in coachInfo.case"
              :key="index"
            >
              <div
                class="case-container-item"
                :class="{ 'case-container-item-first': index == 0 }"
              >
                <WxOpenLaunchApp :extinfo="item.extinfo"></WxOpenLaunchApp>
                <div class="case-item">
                  <div class="c-item-top">
                    <img
                      class="c-item-avatar"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58f1b7711997802b54f06bce56ad313f.png"
                      alt=""
                    />
                    <div class="c-item-t-center">
                      <div class="c-item-nickname">{{ item.truename }}</div>
                      <div class="c-item-alias"
                        >{{ item.product_alias_name }}学员 |
                        {{ item.coach_name }}
                      </div>
                    </div>
                  </div>
                  <div class="c-item-center">
                    <div class="c-info-item">
                      <div class="item-text-c">
                        <div class="item-text">打卡</div>
                        <div class="item-unit">(次数)</div>
                      </div>
                      <div class="change-num">{{ item.clock_time }}</div>
                    </div>
                    <div class="c-info-item">
                      <div class="item-text-c">
                        <div class="item-text">体重</div>
                        <div class="item-unit">(斤)</div>
                      </div>
                      <div
                        class="change-icon iconfont icon-xingzhuangjiehebeifen"
                        :class="{
                          'rotate-icon': item.compare_data.lessWeight > 0
                        }"
                      ></div>
                      <div class="change-num">{{
                        item.compare_data.lessWeight | filterAbs
                      }}</div>
                    </div>
                    <div class="c-info-item">
                      <div class="item-text-c">
                        <div class="item-text">腰围</div>
                        <div class="item-unit">(厘米)</div>
                      </div>
                      <div
                        class="change-icon iconfont icon-xingzhuangjiehebeifen"
                        :class="{
                          'rotate-icon': item.compare_data.lessWeight > 0
                        }"
                      ></div>
                      <div class="change-num">{{
                        item.compare_data.lessWaist | filterAbs
                      }}</div>
                    </div>
                  </div>
                  <div class="c-item-bottom">
                    <div class="c-image-item camp-before">
                      <img
                        class="c-image"
                        :src="
                          item.start_img.start_img_1 ||
                          item.start_img.start_img_2 ||
                          item.start_img.start_img_3
                        "
                        alt=""
                      />
                      <div class="c-flag">入营前</div>
                    </div>
                    <div class="c-image-item camp-after">
                      <img
                        class="c-image"
                        :src="
                          item.end_img.end_img_1 ||
                          item.end_img.end_img_2 ||
                          item.end_img.end_img_3
                        "
                        alt=""
                      />
                      <div class="c-flag">入营后</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="content-item story-container" v-if="coachInfo.story">
        <div class="item-title story-title">ta的故事</div>
        <div class="story-text" v-html="coachInfo.story"></div>
      </div>
      <div class="content-item say-container" v-if="coachInfo.message">
        <div class="item-title say-title">对学员说的话</div>
        <div class="say-text" v-html="coachInfo.message"></div>
      </div>
    </div>
    <div class="desc-container">
      <div class="text1">截止2023年底，我们的营养师已经</div>
      <div class="text2"
        >帮助了<span class="pink">53.2万人</span>，成功瘦身<span class="pink"
          >297.8万斤</span
        ></div
      >
    </div>
    <div class="dynamic-content">
      <div class="title">下面是来自学员的真实反馈</div>
      <div
        class="dynamic-item-container"
        v-for="(item, index) in dynamicList"
        :key="index"
      >
        <DynamicItem class="dynamic-item" :data="item" />
        <WxOpenLaunchApp :extinfo="item.extinfo"></WxOpenLaunchApp>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import DynamicItem from './components/dynamic-item.vue'
import { dynamicList } from './data.js'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import BetterweWxApi from '@/components/wx/control.js'
export default {
  components: { DynamicItem, WxOpenLaunchApp },
  data() {
    return {
      dynamicList: dynamicList,
      coachInfo: null,
      unionid: '',
      nickname: '',
      qrcodeUrl: '',
      qrcodeImage: '',
      extinfo: ''
    }
  },
  computed: {
    swiperWidth() {
      return (315 * window.screen.width) / 375
    },
    activityId() {
      return this.$route?.query?.aid || 1
    }
  },
  filters: {
    filterAbs(num) {
      return Math.abs(num)
    }
  },
  created() {
    this.setExtinfo()
    this.getCoachInfo()
    this.getUnionId()
    this.setShareData()
  },
  mounted() {},
  methods: {
    setExtinfo() {
      let url =
        location.origin +
        '/dietitian-vote/index?activityId=' +
        this.$route.query.aid
      this.extinfo = '/web?url=' + url + '&isLogin=1'
      this.dynamicList.map((item) => {
        item.extinfo =
          '/ugcDetails?tabType=' +
          item.detail.tab_type +
          '&id=' +
          item.detail.id
      })
    },
    bindToRank() {
      this.$router.push({
        path: '/dietitian-vote/rank',
        query: {
          cid: this.$route.query.cid,
          uid: this.$route.query.uid,
          aid: this.$route.query.aid
        }
      })
    },
    autoVote() {
      if (this.$route.query.autoVote) {
        this.bindVote()
      }
    },
    setShareData() {
      let shareData = {
        link: location.href,
        desc: '参与投票有机会领取真人营养师服务>>>',
        title: '人气营养师pick赛，速来投票！',
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享的缩略图的url
      }
      BetterweWxApi.setShareData(shareData, shareData)
    },
    createQrcode() {
      let uid = this.$route?.query?.uid
      if (uid) {
        this.qrcodeUrl =
          location.origin +
          '/dietitian-vote/invite?uid=' +
          uid +
          '&aid=' +
          this.activityId
        let screenWidth = window.screen.width
        let designWidth = 375
        let designQrcodeWidth = 90
        let qrcodeWidth = (screenWidth * designQrcodeWidth) / designWidth
        let canvas = document.getElementById('qrcode')
        if (!canvas) {
          return
        }
        QRCode.toCanvas(
          canvas,
          this.qrcodeUrl,
          { width: qrcodeWidth, height: qrcodeWidth },
          (error) => {
            if (!error) {
              let base64Url = canvas.toDataURL('image/png')
              this.qrcodeImage = base64Url
            }
          }
        )
      }
    },
    async bindVote() {
      if (!this.isWx()) {
        this.$toast('请在微信内打开')
        return
      }
      let code = this.$http._getCookie('token')
      if (!code) {
        this.auth()
        return
      }
      let params = {
        cid: this.$route.query.cid,
        num: 1,
        nickname: this.nickname,
        unionid: this.unionid,
        invite_uid: this.$route.query.uid,
        activity_id: this.activityId
      }
      let res = await this.$http
        .getApp('api/v1/Vote/inviteVote', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('投票成功+1')
          this.getCoachInfo()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    auth() {
      if (!this.isWx()) {
        this.$toast('请在微信内打开')
        return
      }
      let url = location.href
      url = url.includes('?') ? url + '&autoVote=1' : url + '?autoVote=1'
      location.replace(
        'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      )
    },
    isWx() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    async getUnionId() {
      let code = this.$http._getCookie('token')
      if (code) {
        let res = await this.$http
          .getApp('api/v1/Vote/wxAuth', { code, activity_id: this.activityId })
          .catch(() => {})
        if (res) {
          res = res.data
          if (res.code == 200) {
            if (!res.data || Array.isArray(res.data)) {
              /* 如果token校验不通过则重新微信授权 */
              this.auth()
            } else {
              this.unionid = res.data.unionid
              this.nickname = res.data.nickname
              this.autoVote()
            }
          } else {
            this.$toast(res.msg)
          }
        }
      }
    },
    async getCoachInfo() {
      let params = {
        cid: this.$route.query.cid,
        invite_uid: this.$route.query.uid,
        activity_id: this.activityId
      }
      let res = await this.$http
        .postApp('api/v1/Vote/getCoachDietitian', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.coachInfo = this.dealData(res.data)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    dealData(data) {
      if (data.case) {
        data.case.map((item) => {
          item.compare_data.lessWeight = +(
            +item.compare_data.end_weight - +item.compare_data.start_weight
          ).toFixed(1)
          item.compare_data.lessWaist = +(
            +item.compare_data.end_waist - +item.compare_data.start_waist
          ).toFixed(1)
          let url = location.origin + '/case-detail?id=' + item.id
          item.extinfo = '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
        })
      }
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.vote-container {
  overflow: hidden;
  padding: 0px 16px;
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/da65a56352d1285eb2466870a812dcd0.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;

  .v-time {
    margin-top: 100px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: rgba(74, 61, 107, 0.5);
    line-height: 16px;
    padding: 0px 16px;
    margin-bottom: 12px;
  }

  .vote-content {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 16px;

    .user-info {
      padding: 0px 16px;
      display: flex;
      align-items: center;
      height: 35px;
      background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;

      .avatar {
        width: 24px;
        height: 24px;
        object-fit: cover;
        border-radius: 6px;
        overflow: hidden;
        margin-right: 6px;
      }

      .nickname {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        color: #ffffff;
        line-height: 20px;
        margin-right: 6px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
      }
    }

    .vote-info {
      padding: 16px 26px 22px 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .dietitian-avatar {
        width: 118px;
        object-fit: cover;
        height: 118px;
        border-radius: 6px;
        margin-right: 25px;
      }

      .vote-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .dietitian-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 28px;
      }

      .dietitian-num {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #6236ff;
        line-height: 22px;
        margin-bottom: 4px;
      }

      .dietitian-rank {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.3);
        line-height: 17px;
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .rank-btn {
        padding: 0px 10px;
        height: 24px;
        line-height: 24px;
        background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
        border-radius: 12px;
        color: #ffffff;
        font-size: 14px;
        margin-left: 10px;
      }

      .dietitian-btn {
        text-align: center;
        width: 136px;
        height: 36px;
        background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
        border-radius: 18px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 36px;
      }
    }
  }

  .dietitian-info {
    padding: 20px 0px 30px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 28px;

    .content-item {
      padding: 0px 16px;
    }

    .item-title {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 8px;
    }

    .circle-item::after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      left: 2px;
      top: 50%;
      transform: translate(0%, -50%);
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-left: 5px solid rgba(0, 0, 0, 0.5);
      border-right: 0px solid transparent;
    }

    .qualifications-list {
      margin-bottom: 25px;

      .qualifications-item {
        position: relative;
        text-indent: 10px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        margin-bottom: 10px;
      }

      .qualifications-item:last-child {
        margin-bottom: 0;
      }
    }

    .experience-list {
      margin-bottom: 10px;

      .experience-item {
        line-height: 24px;
        position: relative;
        text-indent: 10px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        margin-bottom: 10px;

        .item-num {
          margin-left: 6px;
          font-size: 16px;
          font-family: DIN, DIN;
          font-weight: bold;
          color: #9071ff;
        }
      }

      .experience-item:last-child {
        margin-bottom: 0;
      }
    }

    .change-title {
      padding: 0px 16px;
    }

    .swipe-container {
      margin-bottom: 13px;
      padding-bottom: 15px;
      overflow: hidden;

      ::v-deep .van-swipe {
        overflow: visible;
      }

      ::v-deep .van-swipe__indicators {
        bottom: -14px;
      }

      ::v-deep .van-swipe__indicator {
        width: 4px;
        height: 4px;
        background: rgba(173, 150, 255, 0.24);
        border-radius: 2px;
      }

      ::v-deep .van-swipe__indicator--active {
        width: 16px;
        height: 4px;
        background: #ad96ff;
        border-radius: 2px;
      }

      .case-container-item {
        position: relative;
        display: flex;
        justify-content: flex-start;
      }

      .case-container-item-first {
        display: flex;
        justify-content: flex-end;
      }

      .case-item {
        margin: 0px 8px;
        padding: 10px;
        background: #f9f9f9;
        border-radius: 8px;
        width: 291px;
        box-sizing: border-box;

        .c-item-top {
          display: flex;
          align-items: center;
          margin-bottom: 13px;

          .c-item-avatar {
            width: 36px;
            height: 36px;
            object-fit: cover;
            margin-right: 8px;
          }

          .c-item-t-center {
            .c-item-nickname {
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 17px;
            }

            .c-item-alias {
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.3);
              line-height: 14px;
            }
          }
        }

        .c-item-center {
          display: flex;
          align-items: center;
          margin-bottom: 13px;

          .c-info-item {
            position: relative;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            .item-text-c {
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
              line-height: 11px;
              margin-right: 4px;
              text-align: center;

              .item-text {
              }

              .item-unit {
                font-size: 10px;
              }
            }

            .change-icon {
              width: 10px;
              height: 12px;
              color: rgba(94, 219, 143, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              margin-right: 3px;
            }

            .rotate-icon {
              transform: rotate(180deg);
              color: rgb(252, 36, 36);
            }

            .change-num {
              font-size: 20px;
              font-family: DINCondensed, DINCondensed;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.6);
              line-height: 24px;
            }
          }

          .c-info-item::after {
            content: '';
            position: absolute;
            width: 1px;
            height: 16px;
            background-color: #e1e1e1;
            right: 0;
            top: 50%;
            transform: translate(0%, -50%);
          }

          .c-info-item:last-child::after {
            display: none;
          }
        }

        .c-item-bottom {
          display: flex;
          border-radius: 6px;
          overflow: hidden;

          .c-image-item {
            position: relative;
            flex: 1;
            height: 179px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #ffffff;

            .c-image {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .camp-before {
            .c-flag {
              position: absolute;
              left: 0;
              top: 0;
              width: 60px;
              height: 22px;
              background: rgba(0, 0, 0, 0.6);
              text-align: center;
              line-height: 22px;
              border-bottom-right-radius: 6px;
            }
          }

          .camp-after {
            .c-flag {
              position: absolute;
              right: 0;
              top: 0;
              width: 60px;
              height: 22px;
              background: #8078e9;
              text-align: center;
              line-height: 22px;
              border-bottom-left-radius: 6px;
            }
          }
        }
      }
    }

    .comment-list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;

      .comment-item {
        padding: 0px 8px;
        height: 25px;
        line-height: 25px;
        white-space: nowrap;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        margin-right: 6px;
        margin-bottom: 5px;
      }

      .comment-item:last-child {
        margin-right: 0;
      }
    }

    .story-container {
      margin-bottom: 25px;

      .story-text {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 20px;
        word-break: break-all;
      }
    }

    .say-text {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      word-break: break-all;
    }
  }

  .qrcode-container {
    margin-bottom: 16px;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 16px 23px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .q-title {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 18px;
    }

    .q-text {
      position: relative;
      padding: 0px 8px;
      border-radius: 11px;
      height: 22px;
      line-height: 22px;
      background: #ad96ff;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 14px;
    }

    .q-text::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -5px;
      width: 0;
      height: 0;
      border-top: 6px solid #ad96ff;
      border-bottom: 0px solid transparent;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      transform: translate(-50%, 0%);
    }

    .q-image {
      width: 90px;
      height: 90px;
      margin-bottom: 8px;
    }

    .q-desc {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
    }
  }

  .desc-container {
    padding: 0px 15px;
    margin-bottom: 18px;

    .text1 {
      font-size: 14px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .text2 {
      font-size: 18px;
      font-family: MiSans, MiSans;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;

      .pink {
        font-family: '';
        font-weight: bold;
        color: rgba(255, 106, 151, 1);
      }
    }
  }

  .dynamic-content {
    .title {
      text-indent: 15px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }

    .dynamic-item-container {
      position: relative;
    }
  }

  .rule {
    position: fixed;
    right: 0;
    top: 65px;
    z-index: 33;
    width: 28px;
    text-align: center;
    box-sizing: border-box;
    padding: 8px 6px 11px;
    background: #4a3d6b;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: #ffffff;
    line-height: 14px;
    border-radius: 8px 0px 0px 8px;
  }
}
</style>
